import React from "react";
import { lifeAtSeekho } from "../../utils/constants/Team";
import BGElementBright from "../Icons/TeamAndCulture/LifeAtSeekho/BGElementBright";
import BGElementDark from "../Icons/TeamAndCulture/LifeAtSeekho/BGElementDark";
import Fade from "react-reveal/Fade";
import CustomNextImage from "../common/CustomNextImage";

const LifeAtSeekho = () => {
  return (
    <section>
      <Fade bottom>
        <h6 className="text-[24px] !font-lexend font-semibold text-center lg:text-[40px]">
          Life At Seekho
        </h6>
      </Fade>
      <div
        id="HideScroll"
        className="flex gap-x-2 overflow-x-auto scrollbar-hide px-2 mt-8 lg:px-0 lg:gap-x-4"
      >
        {lifeAtSeekho.map((item, index) => {
          return (
            <div
              key={item?.title}
              className="group px-3 py-2 !min-w-[152px] border border-[#1f1f1f] bg-black cursor-pointer !rounded-2xl relative md:!min-w-[224px] md:!p-4 md:!pt-1"
            >
              <div className="absolute !top-12 left-9 block transition-transform duration-300 group-hover:hidden md:!top-24 md:!left-14">
                <BGElementDark className="w-[104px] md:w-[144px]" />
              </div>
              <div className="absolute hidden !top-12 left-9 transition-transform duration-300 group-hover:block md:!top-24 md:!left-14">
                <BGElementBright className="w-[104px] md:w-[144px]" />
              </div>
              <span className="text-[40px] w-fit text-[#1f1f1f] font-lexend font-semibold transition-colors duration-300 group-hover:text-[#3d3d3d] md:text-[56px]">
                {index + 1}
              </span>
              <CustomNextImage
                src={item?.icon}
                alt={item?.title}
                width={200}
                height={200}
                className="w-[104px] mt-0 ml-1 relative z-10 transition-transform duration-700 group-hover:scale-[1.20] md:mt-4 md:!w-[124px] md:!ml-4"
              />
              <h6
                dangerouslySetInnerHTML={{ __html: item?.title }}
                className="text-[16px] leading-5 font-semibold font-lexend mt-4 md:mt-6 md:text-[24px] md:leading-[32px]"
              />
              <p className="text-[#666666] mt-4 font-lexend font-normal transition-colors duration-300 text-[12px] group-hover:text-[#8f8f8f] md:text-[17px]">
                {item?.desc}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default LifeAtSeekho;
